import { useImpersonation } from '../contexts/ImpersonationContext';
import { X } from 'lucide-react';
import styles from './ImpersonationBanner.module.css';

export default function ImpersonationBanner() {
  const { isImpersonating, targetProfile, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !targetProfile) return null;

  const name = targetProfile.profile?.name || 'Usuário sem nome';
  const email = targetProfile.profile?.email || targetProfile.uid;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.text}>
        Visualizando como <strong>{name}</strong> ({email})
      </span>
      <button
        type="button"
        className={styles.stopBtn}
        onClick={stopImpersonation}
        aria-label="Parar impersonation"
      >
        <X size={16} aria-hidden />
        Parar
      </button>
    </div>
  );
}
